import { Alert, CircularProgress } from "@mui/material"
import PropTypes from "prop-types"
import SkillsLibrary from "connected-components/skills/components/skills-library"

import "./style.scss"

// The view forwards the skill arrays straight to SkillsLibrary, which validates element shape itself.
const SKILLS_STATE_PROP_TYPES = {
  licensedSkills: PropTypes.arrayOf(PropTypes.object),
  proprietarySkills: PropTypes.arrayOf(PropTypes.object),
  skillCategoryOrder: PropTypes.arrayOf(PropTypes.string),
  skillsLoaded: PropTypes.bool.isRequired,
  skillsError: PropTypes.bool,
  canDownload: PropTypes.bool.isRequired,
}

function AgenticWorkflowsContent({ licensedSkills, proprietarySkills, skillCategoryOrder, skillsLoaded, skillsError, canDownload }) {
  if (!skillsLoaded) {
    return <CircularProgress className="modules_agentic-workflows-loading" />
  }

  // Render whatever loaded. A partial failure (e.g. proprietary errored but licensed has
  // workflows) must still show the available catalog rather than a full-page error.
  if (licensedSkills?.length || proprietarySkills?.length) {
    return (
      <SkillsLibrary
        licensedSkills={licensedSkills}
        proprietarySkills={proprietarySkills}
        categoryOrder={skillCategoryOrder}
        canDownload={canDownload}
      />
    )
  }

  if (skillsError) {
    return (
      <Alert severity="error" className="modules_agentic-workflows-error">
        Agentic workflows could not be loaded. Please try refreshing the page.
      </Alert>
    )
  }

  return (
    <Alert severity="info" className="modules_agentic-workflows-empty">
      No agentic workflows are available for this account yet.
    </Alert>
  )
}

AgenticWorkflowsContent.propTypes = SKILLS_STATE_PROP_TYPES

function AgenticWorkflowsModule({ skillsEnabled, ...skillsState }) {
  // Defense in depth: /home/ai is also withFeatureGate'd on skills_delivery, but the route gate
  // fails open while feature flags are still loading, and passthrough skill data persists in Redux
  // across account/flag changes — so never render the catalog when the feature is off, even if a
  // prior account's data is still cached.
  if (!skillsEnabled) {
    return null
  }

  return (
    <div className="modules_agentic-workflows">
      <AgenticWorkflowsContent {...skillsState} />
    </div>
  )
}

AgenticWorkflowsModule.propTypes = {
  ...SKILLS_STATE_PROP_TYPES,
  skillsEnabled: PropTypes.bool,
}

export default AgenticWorkflowsModule
